
import Vue from 'vue'
import store from '../store';
import { INode } from "@/shared/models/node.model";
import ChapterMenu from '../components/ChapterMenu.vue';
import MenuTree from "../components/MenuTree.vue";
import GuidelineArea from '../components/GuidelineArea.vue';
import SiteFooter from "../components/SiteFooter.vue";
import { tdApi } from "@/services/td/td.api.service";
import router from "@/router";
import { HtmlHelper } from "@/shared/lib/htmlhelper";
const siteUrl = "fysisktillganglighet.vgregion.se";

export default Vue.extend({
  name: 'HomeView',
  components: {
    ChapterMenu,
    MenuTree,
    GuidelineArea,
    SiteFooter
  },
  data() {
    return {
      currentItem: {} as INode,
      isMobileMenuOpen: false as boolean,
      startNodeId: 0 as number,
      showChapters: false as boolean,
      selectedChapter: {} as INode,
      tree: [] as INode[],
      isLoaded: false as boolean,
      phrase: "" as string
    };
  },
  async mounted() {
    await this.search();
    this.showChapters = this.$route.params['chapters'] == undefined;    
    
    if (this.$route.params.id) {
      const item = await tdApi.getSelectableNodeById(this.$route.params.id);
      const chapter = this.findChapter(item.Id);
      this.showItem(item, chapter);
      this.startNodeId = item.Id;
    }
    else if (this.$route.path.length > 1) {
      let item = await tdApi.getNodeByUrl(this.$route.path);
      let chapter = {} as INode;
      if (item.Id === 0) {
        if (this.$route.params['chapters'] != undefined) { 
          const routeNumber = this.$route.params['chapters'].split('-')[0];
          chapter = this.tree.find(x => routeNumber === x.Name.split('.')[0]) ?? {} as INode;
          item = chapter;
        }else{
          chapter = {} as INode;
        }
      } else {
        chapter = this.findChapter(item.Id);
      }

      this.showItem(item, chapter);
      this.startNodeId = item.Id;
    }

    if (this.$route.query.phrase) {
      this.phrase = this.$route.query.phrase as string;
    }

    const helper = new HtmlHelper();
    if (window.location.host.toLowerCase() === `www.${siteUrl}` || window.location.host.toLowerCase() === siteUrl) {
      helper.addMatomoCode();
    }
    this.isLoaded = true;
  },
  methods: {
    async search() {
      this.$store.dispatch("setIsTdAdmin");
      await this.$store.dispatch("setTree");

      this.tree = store.state.tree;
    },
    
    showItem(selectedItem: INode, chapter: INode) {
      window.scrollTo(0, 0);
      this.currentItem = selectedItem;
      this.updateUrl(selectedItem);

      if (Object.keys(chapter).length != 0) {
        this.selectedChapter = chapter;
        this.showChapters = false;
      }
    },

    showTree(chapter: INode) {
      this.selectedChapter = chapter;
      this.showChapters = false;
      this.isMobileMenuOpen = true;
      this.updateUrl(chapter);
      this.currentItem = chapter;
      window.scrollTo(0, 0);
    },

    toggleMenu(open: boolean) {
      this.isMobileMenuOpen = open;
    },
    updateUrl(node: INode) {
      const path = this.$route.path.replace("/verktyg", "");
      const url = node.Url == undefined ? "" : node.Url;

      if (path != url) {
        if (process.env.NODE_ENV == "development") {    
          router.push(url)
        } else {   
            if(url.length > 0)
              router.push(`/verktyg${url}`);         
        }
      }

      if (window.location.host.toLowerCase() === `www.${siteUrl}` || window.location.host.toLowerCase() === siteUrl) {
        // eslint-disable-next-line
        var _paq = window._paq = window._paq || [];

        _paq.push(['setCustomUrl', window.location.href]);
        _paq.push(['setDocumentTitle', document.title]);
        _paq.push(['trackPageView']);
      }
    },
    findChapter(id: number) {
      var chapter = {} as INode;
      this.tree.forEach((item) => {
        if (this.isInChapter(id, item, false)) {
          chapter = item;
        }
      });
      return chapter;
    },

    isInChapter(id: number, chapter: INode, found: boolean): boolean {
      if (chapter.Id === id) {
        found = true;
      }
      else if (chapter.Children) {
        chapter.Children.forEach((item) => {
          found = this.isInChapter(id, item, found);

        });
      }
      return found;
    }
  },
})
